import { render } from "./SponsorForm.vue?vue&type=template&id=13974e54&scoped=true"
import script from "./SponsorForm.vue?vue&type=script&lang=js"
export * from "./SponsorForm.vue?vue&type=script&lang=js"

import "./SponsorForm.vue?vue&type=style&index=0&id=13974e54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13974e54"]])

export default __exports__